<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    const cnzz_protocol =
      "https:" == document.location.protocol ? " https://" : " http://";
    document.write(
      unescape(
        "%3Cspan style='display:none' id='cnzz_stat_icon_5768887'%3E%3C/span%3E%3Cscript src='" +
          cnzz_protocol +
          "s17.cnzz.com/stat.php%3Fid%3D5768887' type='text/javascript'%3E%3C/script%3E"
      )
    );
  }
};
</script>